export const it_upload = {
    'title_modal': 'CARICA IL TUO FILE',
    'description_modal': 'Descrizione file'
};